import { createGlobalStyle } from "styled-components";

// TODO cleanup / remove everything that's not critical. Use SC instead.
export const GlobalStyles = createGlobalStyle`
    body {
        margin: 0;
        font-family: ${({ theme }) => theme.fontFamilyPrimary};
    }

    h1 {
        font-size: 48px;
        @media (min-width: 480px) {
            font-size: 64px;
            text-transform: uppercase;
          }
    }

    h2 {
        font-size: 30px;
    }

    h3 {
        font-size: 24px;
    }

    h1, h2, h3, h4, h5, h6 {
        margin: 0px;
        font-family: ${({ theme }) => theme.fontFamilySecondary};
        text-align: inherit;
    }

    hr {
        border-top: 1px solid #b3b3b3;
    }

    /* select {
        padding: 15px;
        width: 100%;
        background: white;
        outline: none;
        border: 1px solid #2e2e2e;
        font-size: 16px;
        cursor: pointer;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg fill='%23666666' height='34' viewBox='0 0 24 24' width='34' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-position-Y: 50%;
        background-position-X: 98%;
        background-repeat: no-repeat;
    }

    select:active {
        border: 1px solid ${({ theme }) => theme.primary};
    }

    .active-option, .action-option:hover {
        box-shadow: 0 0 0 2px ${({ theme }) => theme.primary} !important;
    } */

    p {
        font-size: 18px;
        line-height: 1.5;
    }

    thead {
        border-bottom: none !important;
    }

    a {
        color: inherit;
        text-decoration: none;

        // The progress bar contains a div that is targeted to style properly
        &.active span {
                background: ${({ theme }) => theme.progressBarHighlight};
        }

        &.disabled{
            pointer-events: none;
            cursor: not-allowed;
        }
    }

    // TODO ta bort?
    .overlay {
        height: 100%;
        width: 100%;

        opacity: 0.35;
        transition: 0.25s;
    }

    input {
        padding: 10px;
        font-size: 16px;
    }

    // TODO - move to tooltip css
    .tooltip-container {
        position: fixed;
        top: 15%;
        right: 0;
        left: 0;
        border: 1px solid #ccc;
        background: #fff;
        overflow-y: auto;
        border-radius: 4px;
        outline: none;

        // Scensum has its own styling for p-tags for example, having 0 margin-top.
        // This might cause the test env to sometimes look like the margin-top is to high inside the Modal
        padding: 30px 10px;

        @media (min-width: 480px) {
            top: 20%;
            left: 10%;
            right: 10%;
        }
        
        @media (min-width: 768px) {
            padding: 40px;
        }
    }

    .tooltip-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0, 0.5);
    }

    button {
        background: ${({ theme }) => theme.link};
        color: white;
        padding: 10px 10px;
        border: none;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        filter: brightness(1);
        transition: filter .15s;
        -webkit-font-smoothing: antialiased;
	    -moz-osx-font-smoothing: grayscale;

        &:disabled, &:disabled a {
            opacity: 0.5;
            cursor: not-allowed;

            &:hover {
              filter: brightness(1);
            }
        }

        &:focus {
          outline: none;
        }

        &:hover {
          filter: brightness(1.2);
        }
    }

    .ReactModal__Html--open, .ReactModal__Body--open {
        overflow: hidden;
    }

    .ReactModal__Overlay {
        opacity: 0;
        transition: opacity 300ms ease-in-out;
    }

    .ReactModal__Overlay--after-open{
        opacity: 1;
        z-index: 99;
    }

    .ReactModal__Overlay--before-close{
        opacity: 0;
    }

    .ReactModal__Content {
        max-height: calc(80vh);
        max-width: 98%;
        margin: 0 auto;
        overflow-y: auto;

        @media (min-width: 480px) {
            max-width: 75%;
        }
      }

    .fade-enter {
        opacity: 0.01;
      }

    .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
    }

    .fade-leave {
    opacity: 1;
    }

    .fade-leave.fade-leave-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
    }

    .fade-appear {
    opacity: 0.01;
    }

    .fade-appear.fade-appear-active {
    opacity: 1;
    transition: opacity .3s ease-in;
    }

    .hide-on-print {
        @media print {
            display: none;
         }
    }

    @media print {
        h1 {
            color: #000;
            background: none;
        }

        h2, h3 {
            page-break-after: avoid;
        }

        nav, aside {
            display: none;
        }

        body {
            width: 100%;
            margin: 0;
            padding: 0;
        }

        img {
            max-width: 100% !important;
            display: block;
            width: 10cm;
            height: auto;
        }

        ul, img {
            page-break-inside: avoid;
        }

        @page {
            margin: 2cm;
        }
    }
`;
